import { render, staticRenderFns } from "./BuyOrderSummary.vue?vue&type=template&id=8c29d990&"
import script from "./BuyOrderSummary.vue?vue&type=script&lang=js&"
export * from "./BuyOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports